<template>
    <ul
        v-if="result && result.listings && result.listings.length > 0"
        :class="[
            'house-grid',
            'template4',
            'count-' +
                (result.listings.length > 5 ? 'any' : result.listings.length),
            isGallery ? 'gallery' : ''
        ]"
    >
        <house
            v-for="(item, index) in result.listings"
            :key="item.detailLink"
            :house="item"
            :dir="
                (index <= 1 && isGallery) || isMobile ? 'width' : 'height'
            "
            :showCheckbox="showCheckbox"
            @mouseenter="onMouseEnter(item.id)"
            @mouseleave="onMouseLeave(item.id)"
            @checked="onChecked(item.id)"
            v-lazy="index === 3 ? { callback: handleScroll } : {}"
        />
        <i
            v-show="showGotoTop"
            @click="handleGotoTop"
            class="btn-goto-top iconfont icon-top_v4"
        ></i>
        <div
            class="house-grid-item more-link template4"
            v-if="
                moreLink &&
                    isGallery &&
                    result.listings.length > 4 &&
                    !wordPressSSR
            "
        >
            <a
                :href="moreLink"
                :style="moreStyle"
                :aria-label="moreLinkPurpose"
                rel="noopener noreferrer"
            >{{ moreText || $t('md-house.viewMoreFeaturedListings') }}</a>
        </div>
    </ul>
</template>

<script>
import Core from '../list';
import house from './house.vue';
export default {
    mixins: [Core],
    props: [
        'isGallery',
        'moreLink',
        'moreText',
        'moreStyle',
        'moreLinkPurpose'
    ],
    components: {
        house
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.house-grid.template4 {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    width: calc(100% + 20px);
    margin-left: -10px;
    margin-top: -10px;
    margin-bottom: -10px;
    position: relative;
    max-width: 100vw;
    &.full-screen {
        .house-grid-item {
            width: calc(25% - 20px);
            @media (max-width: 1319px) {
                width: calc(33.33% - 20px);
            }
            @media (max-width: 999px) {
                width: calc(50% - 20px);
            }
            @media (max-width: 600px) {
                width: 100%;
                margin: 0;
            }
        }
    }
    &.small {
        padding: 0 20px;
        .house-grid-item {
            width: calc(50% - 20px);
        }
    }
    &.gallery {
        margin: 0;
        width: 100%;
        .house-grid-item {
            padding: 0;
            margin: 0;
            width: 16.66%;
            @media (max-width: 1639px) {
                width: 25%;
            }
            @media (max-width: 1319px) {
                width: 33.33%;
            }
            @media (max-width: 999px) {
                width: 50%;
            }
            @media (max-width: 600px) {
                width: 100%;
            }
            &.more-link {
                background-image: url('//cdn.chime.me/image/fs/sitebuild/w2200_original_house-link.png');
                a {
                    font-size: 13px;
                    color: white;
                    padding: 6px 20px;
                    border: 2px solid white;
                    white-space: nowrap;
                    line-height: 16px;
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    max-width: 80%;
                    @include ellipsis();
                }
                @include media-600 {
                    background: white;
                    a {
                        color: white;
                        display: block;
                        border: none;
                        position: static;
                        transform: none;
                        width: 60%;
                        height: 25px;
                        padding: 0 15px;
                        text-align: center;
                        line-height: 25px;
                        margin: 20px auto 0;
                        background-color: rgba(188, 188, 202, 0.8);
                        text-transform: uppercase;
                    }
                }
            }
            // &.active {
            //     .mask {
            //         width: 230px;
            //     }
            // }
            @include media-min-600 {
                .mask {
                    width: 100%;
                    left: 0;
                }
            }
        }
        @include media-min-600 {
            &.count-5 .house-grid-item {
                &:nth-child(-n + 2) {
                    width: 50%;
                    height: 560px;
                }

                &:nth-child(n + 3) {
                    width: 25%;
                    height: 460px;
                }
            }

            &.count-4 .house-grid-item,
            &.count-2 .house-grid-item {
                width: 50%;
                height: 560px;
            }

            &.count-3 .house-grid-item {
                width: 33.333%;
                height: 560px;
            }

            &.count-1 .house-grid-item {
                width: var(--module-width, 1000px);
                max-width: 100%;
                height: 560px;
                margin: 0 auto;
                float: none;
            }
        }
    }
    .btn-goto-top {
        position: fixed;
        top: 50%;
        right: 10px;
        height: 40px;
        width: 40px;
        margin: 0;
        background-color: #fff;
        color: #8b93a7;
        padding: 0;
        text-align: center;
        line-height: 38px;
        box-shadow: 0 3px 2px 0 rgba(170, 186, 218, 0.09);
        border: 1px solid #ebecf0;
        z-index: calc(var(--level-low) + 11);
    }
    .house-grid-item {
        width: calc((100% - 60px) / 3);
        margin: 10px;
    }
    @include media-800 {
        .house-grid-item {
            width: 50%;
        }
    }

    @include media-600 {
        width: 100%;
        margin: 0;
        .house-grid-item {
            width: 100%;
            height: auto;
            margin: 0 0 10px;
            padding: 0;
        }
        &.has-more {
            padding-bottom: 45px;
            position: relative;
            .mg-title {
                position: static;
                a.mg-more {
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    transform: translateX(-50%);
                }
            }
        }
    }
}
</style>
